module.exports = __webpack_public_path__ + "static/irishWaltzOfFlower-57a66b0a09ab3adb1eb83d8d41b22e94.mp3";